// src/components/Header.js
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/images/logo.png';

function Header() {
  // Menu data structure
  const menuItems = [
    // {
    //   title: "Products",
    //   path: "/",
    //   submenu: [
    //     { title: "Server Infrastructure Support", path: "/Server-Infrastructure-Support" },
    //     { title: "Cloud Infrastructure Solutions", path: "/Cloud-Infrastructure-Solutions" },
    //     { title: "Server Infrastructure Platform", path: "/Server-Infrastructure-Platform" },
    //     { title: "Onboarding Platform", path: "/onboarding-platform" }
    //   ]
    // },
    {
      title: "Service",
      path: "/",
      submenu: [
        { title: "Profession Check", path: "/profession-check" },
        { title: "Vehicle Verigication", path: "/vehicle-verigication" },
        { title: "KYC Verigication API", path: "/kyc-verigication-api" },
        { title: "Business API", path: "/business-api" },
        { title: "Financical Check API", path: "/financical-check-api" }
      ]
    },

    {
      title: "Pricing",
      path: "/Pricing"
    },

    {
      title: "Partner With us",
      path: "/Partnerwithus"
    },
    {
      title: "API Platforms ",
      path: "/ApiPlatform"
    },
    {
      title: "About ",
      path: "/About"
    },
    {
      title: "Contact ",
      path: "/Contact",
      
    },
    {
      title: "Contact Us",
      path: "/Contact",
      highlighted: true
    }
  ];

  return (
    <header className="main-header">
      <div className="header-sticky">
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            {/* Logo Start */}
            <Link className="navbar-brand" to="/">
              <img src={logo} alt="Logo" />
            </Link>
            {/* Logo End */}
            
            {/* Main Menu Start */}
            <div className="collapse navbar-collapse main-menu">
              <div className="nav-menu-wrapper">
                <ul className="navbar-nav mr-auto" id="menu">
                  {menuItems.map((item, index) => (
                    <li 
                      key={index} 
                      className={`nav-item ${item.submenu ? 'submenu' : ''} ${item.highlighted ? 'highlighted-menu' : ''}`}
                    >
                      <NavLink 
                        className="nav-link" 
                        to={item.path} 
                        end={item.path === "/"}
                      >
                        {item.title}
                      </NavLink>
                      
                      {item.submenu && (
                        <ul>
                          {item.submenu.map((subItem, subIndex) => (
                            <li key={subIndex} className="nav-item">
                              <NavLink className="nav-link" to={subItem.path}>
                                {subItem.title}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              
              {/* Header Btn Start */}
              <div className="header-btn d-inline-flex">
                {/* <Link to="/Signin" className="btn-default btn-highlighted">
                  Login
                </Link> */}
                <a href="https://merchant.payinfintech.com/signin" className="btn-default btn-highlighted">Login</a>
              </div>
              {/* Header Btn End */}
            </div>
            {/* Main Menu End */}
            
            <div className="navbar-toggle" />
          </div>
        </nav>
        <div className="responsive-menu" />
      </div>
    </header>
  );
}

export default Header;